webpackJsonp([263791100135453],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
		return _react2.default.createElement(
			"div",
			{ className: "page-wrapper" },
			_react2.default.createElement(_reactHelmet2.default, { title: "About Us - Falken's Party Supplies" }),
			_react2.default.createElement(
				"section",
				{ id: "primary-hero", className: "about-hero" },
				_react2.default.createElement(
					"h1",
					null,
					"About Us"
				),
				_react2.default.createElement(
					"p",
					null,
					"blah blah. something for seo reasons"
				)
			),
			_react2.default.createElement(
				"section",
				{ className: "basic-page" },
				_react2.default.createElement(
					"div",
					{ className: "container" },
					_react2.default.createElement(
						"p",
						null,
						"blah blah"
					)
				)
			)
		);
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-8c42496c8ac49f6ad0f7.js